import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModalComponent } from '@carm/shared/components/modal/modal.component';
import { BasePageComponent } from '@carm/_utils/base-page.component';

@Injectable()
export class LeaveUploadGuard  {

  // configre any legal routes not covered by guard rules
  ignoreRoutes: string[] = [
    RoutesConst.UploadDocuments_StepThree_Rel,
  ];

  constructor(
    private matDialog: MatDialog,
    private translateService: TranslateService,
  ) {

  }
  canDeactivate(
    component: BasePageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      for (const route of this.ignoreRoutes) {
        if (nextState?.url?.includes(route)) {
          return true;
        }
      }

      if(component.showLeavingWarning){
        const areYouSureDialog: MatDialogRef<ModalComponent> = this.matDialog.open(ModalComponent, {
          data: {
            title: this.translateService.instant('leave_upload_guard.leaveUplodForm'),
            contentParagraphs: [
              this.translateService.instant('leave_upload_guard.areYouSure'),
              this.translateService.instant('leave_upload_guard.dataWillBeLost')],
            buttons: [
              {id: 'cancel', label: this.translateService.instant('button.cancel')},
              {id: 'leave', label: this.translateService.instant('button.leave')},
            ],
          },
        });
        return areYouSureDialog.afterClosed()
          .pipe(
            map((buttonId) => {



              switch (buttonId) {
                case 'cancel': {
                  return false;
                }
                case 'leave': {
                  component.showLeavingWarning = false;
                  return true;
                }
                default: {
                  return false;
                }
              }
            }),
          );
      }else{
        return true;
      }
  }
}
